import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import {
  Icon,
  Notification,
  FullViewContainer,
  CircledLabel,
} from "../common/style";
import {
  GroupInfoContainer,
  OrderItemContainer,
  AccordionHeaderContainer,
  ExpoIcon,
  RightArrowPointer,
} from "./style";
import ProjectDropDown from "./ProjectDropDown";
import CrudModal from "./CrudModal";
import { useContext } from "react";
import { AppContext } from "../context";

import {
  addUserGroup,
  updateUserGroup,
  sortContainerOrderItems,
  sortGroupOrderItems,
} from "./service";
import { useNavigate, useParams } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MaterialImg from "../assets/img/material.svg";
import { isInternalAccess } from "../common/service";
import { BASE_TYPES } from "../constants";

const ModuleListAccordion = ({
  isLoading,
  setIsLoading,
  currentRoom,
  projectSummary,
  selectionManager,
  setCurrentGroup,
  projectId,
  loadRoom,
  setIsReset,
  hoverItem,
  setHoverItem,
  isEq,
  access,
  moduleIds,
  fromOrderReview,
  summary,
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const { setClearSearch, setIsSubModule } = useContext(AppContext);
  const [openedAccordionId, setOpenedAccordionId] = useState("0");
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [currentEditModalName, setCurrentEditModalName] = useState(null);
  const [groupDropdown, setGroupDropdown] = useState({});
  const [addGroupModal, setAddGroupModal] = useState(false);
  const [editGroup, setEditGroup] = useState(false);

  const EXCLUDED_CART_PILLS = [
    "height",
    "depth",
    "width",
    "exposed_side_top",
    "exposed_side_right",
    "exposed_side_left",
    "exposed_side_bottom",
    "shutter",
    "handle",
  ];
  const colorProperties = ["shutter_color", "internal_color"];
  const materialProperties = [
    "carcass_material",
    "shutter_material",
    "backsheet_material",
  ];
  const [open, setOpen] = useState(["0"]);
  const [isPopoverOpen, setIsPopoverOpen] = useState(null);
  const [isAddOnPopoverOpen, setIsAddOnPopoverOpen] = useState("");
  const [orderItemBoundingClients, setOrderItemBoundingClients] =
    useState(null);
  const [priceHover, setPriceHover] = useState("");

  const unitsMapper = {
    square_feet: "sq.ft.",
    running_feet: "rft.",
    number: "nos.",
  };
  const unitMapper = {
    square_feet: "/ sq.ft.",
    running_feet: "/ rft.",
    number: "/ no.",
  };

  const shellNoUnitAddons = ["plinth"];

  const toggle = (id) => {
    if (open.includes(id)) setOpen(open.filter((openId) => openId !== id));
    else setOpen([...open, id]);
  };

  const togglePopover = (event, orderItem) => {
    if (!isPopoverOpen || isPopoverOpen.id != orderItem.id) {
      setIsPopoverOpen(orderItem);
      setOrderItemBoundingClients(
        event.target.parentElement.parentElement.parentElement.getBoundingClientRect()
      );
    } else clearPopover();
  };

  const clearPopover = () => {
    setIsAddOnPopoverOpen(null);
    setIsPopoverOpen(null);
    setOrderItemBoundingClients(null);
  };

  const toggleAddOnPopover = (id) => {
    if (isAddOnPopoverOpen == id) return;
    else setIsAddOnPopoverOpen(id);
  };

  const toggleAddGroup = () => setAddGroupModal(!addGroupModal);
  const toggleEditGroup = () => setEditGroup(!editGroup);

  const toggleGroupDropdown = (groupId) => {
    setGroupDropdown((prevState) => ({
      ...prevState,
      [groupId]: prevState[groupId] === groupId ? "-1" : groupId,
    }));
  };

  useEffect(() => {
    currentRoom.groups.forEach((group, index) => {
      group.modules.forEach((orderItem) => {
        if (
          selectionManager.isOrderItemSelected(orderItem.id) &&
          !open.includes(index + "")
        )
          toggle(index + "");
      });
    });
  }, [selectionManager]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Escape") clearPopover();
  };

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const addGroup = ({ projectId, roomId, payload }) => {
    setIsLoading(true);

    return addUserGroup({ projectId, roomId, payload })
      .then(({ group }) => {
        updateLocalProject({
          entity: "group",
          entityId: group.id,
          entityName: group.name,
          parentId: roomId,
          action: "add",
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const updateGroup = ({ projectId, groupId, roomId, payload }) => {
    setIsLoading(true);

    return updateUserGroup({ projectId, groupId, payload })
      .then((_) => {
        updateLocalProject({
          entity: "group",
          entityId: groupId,
          entityName: payload.name,
          parentId: roomId,
          action: "update",
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const updateLocalProject = ({
    entity = "room",
    entityId,
    entityName,
    parentId = null, // roomId for entity 'Group'
    action,
  }) => {
    if (entity === "group") {
      return updateLocalGroup({
        groupId: entityId,
        groupName: entityName,
        roomId: parentId,
        action,
      });
    }
  };

  const updateLocalGroup = ({ roomId, groupName, groupId, action }) => {
    // Mutating "project" -> To update the group names in module "Add To Room" CTA
    switch (action) {
      case "add": {
        currentRoom.groups.push({
          id: groupId,
          name: groupName,
          modules: [],
          position: { x: 0, y: 0 },
          dimensions: { height: 0, width: 0, depth: 0 },
          type: "group",
          category: "StackedGroup",
        });

        break;
      }
      case "update": {
        const groupIndex = currentRoom.groups.findIndex(
          (group) => group.id == groupId
        );

        currentRoom.groups[groupIndex].name = groupName;
        currentRoom.groups[groupIndex] = {
          ...currentRoom.groups[groupIndex],
          name: groupName,
        };

        break;
      }
      case "delete": {
        currentRoom.groups = currentRoom.groups.filter(
          (group) => group.id !== groupId
        );

        loadRoom(currentRoom.id);

        break;
      }
    }
  };

  const getOrderItems = (items, orderItems = []) => {
    const [itemValue] = Object.values(items);
    const itemKeys = Object.keys(items);

    if (typeof itemValue === "boolean") {
      return orderItems.push(itemKeys);
    }

    for (const item in items) {
      getOrderItems(items[item], orderItems);
    }

    return orderItems.flat();
  };

  const [sortingContainer, setSortingContainer] = useState({});
  const [sortingGroup, setSortingGroup] = useState({});

  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: "none",
    background: isDragging ? "lightgreen" : "",
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "lightblue" : "",
  });

  const reorderContainer = (container, startIndex, endIndex) => {
    const result = container.children;
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    const sortPayload = result.map((item, index) => {
      const orderItem = {};
      orderItem.id = item.id;
      orderItem.sort_position = index + 1;

      return orderItem;
    });

    setIsLoading(true);

    sortContainerOrderItems({
      projectId: projectId,
      orderItemId: container.id,
      payload: sortPayload,
      groupId: sortingGroup.id,
    })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => {
        setIsLoading(false);
      });

    return result;
  };

  const reorderItems = ({
    projectId,
    sourceGroupId,
    destinationGroupId,
    movedItemId,
    sortPayload,
    actionType,
  }) => {
    setIsLoading(true);

    sortGroupOrderItems({
      projectId,
      groupId: destinationGroupId,
      payload: {
        sourceGroupId,
        movedItemId,
        sortPayload,
        actionType,
      },
    })
      .then(() => loadRoom(currentRoom.id))
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const reorderGroup = (group, startIndex, endIndex) => {
    if (!group) {
      console.error("Error: group is undefined.");
      return;
    }

    const result = Array.from(group.modules);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    const sortPayload = result.map((item, index) => ({
      id: item.id,
      sort_position: index + 1,
    }));

    reorderItems({
      projectId,
      sourceGroupId: group.id,
      destinationGroupId: group.id,
      movedItemId: null,
      sortPayload,
      actionType: "reorder",
    });
  };

  const moveItemBetweenGroups = (
    sourceGroup,
    destinationGroup,
    sourceIndex,
    destinationIndex
  ) => {
    if (!sourceGroup || !destinationGroup) {
      console.error("Error: Source group or destination group is undefined.");
      return;
    }

    const sourceItems = Array.from(sourceGroup.modules);
    const destinationItems = Array.from(destinationGroup.modules);

    const [movedItem] = sourceItems.splice(sourceIndex, 1);
    destinationItems.splice(destinationIndex, 0, movedItem);

    movedItem.group_id = destinationGroup.id;

    const sortPayload = destinationItems.map((item, index) => ({
      id: item.id,
      sort_position: index + 1,
    }));

    reorderItems({
      projectId,
      sourceGroupId: sourceGroup.id,
      destinationGroupId: destinationGroup.id,
      movedItemId: movedItem.id,
      sortPayload,
      actionType: "move",
    });
  };

  const addItemToGroup = (item, destinationGroup, destinationIndex) => {
    if (!destinationGroup) {
      console.error("Error: destination group is undefined.");
      return;
    }
    const destinationItems = Array.from(destinationGroup.modules);

    destinationItems.splice(destinationIndex, 0, item);
    item.group_id = destinationGroup.id;

    const sortPayload = destinationItems.map((item, index) => ({
      id: item.id,
      sort_position: index + 1,
    }));

    reorderItems({
      projectId,
      sourceGroupId: null,
      destinationGroupId: destinationGroup.id,
      movedItemId: item.id,
      sortPayload,
      actionType: "add",
    });
  };

  const removeItemFromGroup = (sourceGroup, movedItem, sourceIndex) => {
    if (!sourceGroup) {
      console.error("Error: Source group is undefined.");
      return;
    }
    const sourceItems = Array.from(sourceGroup.modules);

    sourceItems.splice(sourceIndex, 1);

    const sortPayload = sourceItems.map((item, index) => ({
      id: item.id,
      sort_position: index + 1,
    }));

    reorderItems({
      projectId,
      sourceGroupId: sourceGroup.id,
      destinationGroupId: sourceGroup.id,
      movedItemId: movedItem.id,
      sortPayload,
      actionType: "remove",
    });
  };

  const onContainerDragEnd = (result) => {
    if (!result.destination || !Object.keys(sortingContainer).length) return;

    reorderContainer(
      sortingContainer,
      result.source.index,
      result.destination.index
    );
  };

  const onGroupDragEnd = (result) => {
    if (!result.destination) return;

    const sourceId = result.source.droppableId;
    const destinationId = result.destination.droppableId;

    if (sourceId === destinationId) {
      const group = currentRoom.groups.find(
        (g) => g.id.toString() === sourceId
      );
      reorderGroup(group, result.source.index, result.destination.index);
    } else {
      const sourceGroup = currentRoom.groups.find(
        (g) => g.id.toString() === sourceId
      );
      const destinationGroup = currentRoom.groups.find(
        (g) => g.id.toString() === destinationId
      );

      if (sourceGroup && destinationGroup) {
        moveItemBetweenGroups(
          sourceGroup,
          destinationGroup,
          result.source.index,
          result.destination.index
        );
      } else if (sourceGroup) {
        const movedItem = sourceGroup.modules[result.source.index];

        removeItemFromGroup(sourceGroup, movedItem, result.source.index);
      } else {
        const outsideItem = currentRoom.modules[result.source.index];
        addItemToGroup(outsideItem, destinationGroup, result.destination.index);
      }
    }
  };

  const selectItem = (item, isShiftKey) => {
    setIsReset(true);
    if (item.type === "module" && !item.is_new_mode) {
      // For old mode modules, load the legacy view.
      selectionManager.clear();
      navigate(
        `/projects/${params.projectId}/catalogs/${item.product_id}/v1?projectId=${projectId}&groupId=${item.group_id}&orderItemId=${item.id}&roomId=${currentRoom.id}`
      );
    } else {
      selectionManager.toggle(item, isShiftKey);
      navigate(`/projects/${projectId}/rooms/${currentRoom.id}/canvas`);
    }
  };

  const ItemContainer = (props) => {
    const {
      orderItem,
      index,
      group,
      providedref,
      draggableprops,
      draghandleprops,
      style,
      childItems = false,
    } = props;
    function capitalizeWords(str) {
      return str
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }

    return (
      <OrderItemContainer
        onClick={(e) => selectItem(orderItem, e.shiftKey)}
        className={`${
          !orderItem.group_id && "ps-2"
        } summary-item order-item hover-item row align-items-center
          ${selectionManager.isOrderItemSelected(orderItem.id) && "active"}
        } ${orderItem.is_container_child ? "ps-5" : ""}
          ${isEq(hoverItem, orderItem) && "hover"}`}
        key={index}
        ref={providedref || null}
        {...draggableprops}
        {...draghandleprops}
        style={style}
        onMouseEnter={() => {
          setHoverItem(orderItem);
        }}
        onMouseLeave={() => {
          setHoverItem(null);
        }}
      >
        <div
          className="col-6 px-0 pointer flex-grow-1"
          onClick={(e) => {
            selectItem(orderItem, e.shiftKey);
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              {summary?.label && orderItem.label && (
                <CircledLabel className="me-2">{orderItem.label}</CircledLabel>
              )}
              <div className="item-name" title={orderItem.name}>
                {orderItem.name}
                {orderItem.sku && (
                  <span className="m-0 grey_letter">
                    {` (${orderItem.sku})`}
                    {isInternalAccess() && (
                      <span className="ms-2">#{orderItem.id}</span>
                    )}
                  </span>
                )}
              </div>
            </div>
            {summary?.price && orderItem.price && (
              <div
                onMouseEnter={() =>
                  orderItem.price_meta && setPriceHover(orderItem.id)
                }
                onMouseLeave={() => orderItem.price_meta && setPriceHover("")}
                onClick={(e) => {
                  if (orderItem.price_meta) {
                    togglePopover(e, orderItem);
                    e.stopPropagation();
                  }
                }}
                className={`px-1 rounded-3 pointer ${
                  ((isPopoverOpen && isPopoverOpen.id == orderItem.id) ||
                    priceHover == orderItem.id) &&
                  "active-dimension active-dimension-outline"
                }`}
              >
                ₹{roundNumber(orderItem.price).toLocaleString("en-IN")}
              </div>
            )}
          </div>
          {(summary?.measurement || summary?.price || summary?.expo) && (
            <div className="d-flex justify-content-between align-items-center mt-1">
              {summary?.measurement && (
                <div className="dimensions">
                  <i
                    className="fa-solid fa-ruler"
                    style={{ marginRight: "2px" }}
                  />
                  {orderItem.dimensions.height} x {orderItem.dimensions.width} x{" "}
                  {orderItem.dimensions.depth}
                </div>
              )}
              {summary?.expo &&
                orderItem.customizations.exposed_sides.some(
                  (side) => side !== null
                ) && (
                  <>
                    <ExpoIcon
                      height="18px"
                      width="20px"
                      id={`expo_${index}`}
                      className={orderItem.customizations.exposed_sides
                        .filter((side) => side !== null)
                        .join(" ")}
                    >
                      E
                    </ExpoIcon>
                    <UncontrolledTooltip
                      style={{
                        fontSize: "16px",
                        padding: "6px 20px",
                      }}
                      target={`expo_${index}`}
                      placement="right"
                    >
                      Expo:{" "}
                      {orderItem.customizations.exposed_sides
                        .filter((side) => side !== null)
                        .join(", ")}
                    </UncontrolledTooltip>
                  </>
                )}
              {summary?.price && orderItem.price_per_sqft && (
                <p className="m-0 text-secondary">
                  ₹
                  {roundNumber(orderItem.price_per_sqft).toLocaleString(
                    "en-IN"
                  )}{" "}
                  / sq.ft.
                </p>
              )}
            </div>
          )}
          {summary?.color && (
            <div className="mt-1">
              {colorProperties.map((prop) => {
                const property = orderItem.customizations.selected_values[prop];
                if (!property) return null;

                const tooltipId = `_${prop}_${index}`;

                return (
                  <React.Fragment key={tooltipId}>
                    <div className="dimensions" key={tooltipId} id={tooltipId}>
                      <i className="fa-solid fa-palette" />{" "}
                      {property.short_name || property.name}
                    </div>
                    <UncontrolledTooltip
                      style={{
                        fontSize: "16px",
                        padding: "6px 20px",
                      }}
                      target={tooltipId}
                      placement="right"
                    >
                      {`${property.name} (${capitalizeWords(prop)})`}
                    </UncontrolledTooltip>
                  </React.Fragment>
                );
              })}
            </div>
          )}
          {summary?.material && (
            <div className="mt-1">
              {materialProperties.map((prop) => {
                const property = orderItem.customizations.selected_values[prop];
                if (!property) return null;

                const tooltipId = `_${prop}_${index}`;

                return (
                  <React.Fragment key={tooltipId}>
                    <div className="dimensions" key={tooltipId} id={tooltipId}>
                      <img style={{ marginRight: "2px" }} src={MaterialImg} />{" "}
                      {property.short_name || property.name}
                    </div>
                    <UncontrolledTooltip
                      style={{
                        fontSize: "16px",
                        padding: "6px 20px",
                      }}
                      target={tooltipId}
                      placement="right"
                    >
                      {`${property.name} (${capitalizeWords(prop)})`}
                    </UncontrolledTooltip>
                  </React.Fragment>
                );
              })}
            </div>
          )}
          {summary?.others && (
            <div className="mt-1">
              {Object.keys(orderItem.customizations.selected_values).map(
                (prop) => {
                  if (
                    !EXCLUDED_CART_PILLS.concat(colorProperties)
                      .concat(materialProperties)
                      .includes(prop)
                  ) {
                    const tooltipId = `${prop}_${index}`;

                    return (
                      <React.Fragment key={tooltipId}>
                        <div
                          className="dimensions"
                          key={tooltipId}
                          id={tooltipId}
                        >
                          <i
                            className="fa-solid fa-sliders"
                            style={{ marginRight: "2px" }}
                          />{" "}
                          {prop === "minifix" &&
                            (orderItem.customizations.selected_values[prop]
                              .identifier === "yes"
                              ? "Minifix"
                              : "No Minifix")}
                          {prop === "pre_milling" &&
                            (orderItem.customizations.selected_values[prop]
                              .identifier === "pre_milling_yes"
                              ? "Pre-Milling"
                              : "No Pre-Milling")}
                          {prop !== "minifix" &&
                            prop !== "pre_milling" &&
                            orderItem.customizations.selected_values[prop].name}
                        </div>
                        <UncontrolledTooltip
                          style={{
                            fontSize: "16px",
                            padding: "6px 20px",
                          }}
                          target={tooltipId}
                          placement="right"
                        >
                          {capitalizeWords(prop)}
                        </UncontrolledTooltip>
                      </React.Fragment>
                    );
                  }
                }
              )}

              {orderItem.has_attachments && (
                <>
                  <i className="fa-solid fa-paperclip p-2" id="attachment"></i>
                  <UncontrolledTooltip target={"attachment"} placement="bottom">
                    This module has one or more attachments
                  </UncontrolledTooltip>
                </>
              )}
              {orderItem.remarks && (
                <>
                  <i
                    className="fa-regular fa-comment p-2"
                    id={`remark_${orderItem.id}`}
                  ></i>
                  <UncontrolledTooltip
                    target={`remark_${orderItem.id}`}
                    placement="bottom"
                  >
                    {orderItem.remarks}
                  </UncontrolledTooltip>
                </>
              )}
            </div>
          )}
        </div>
      </OrderItemContainer>
    );
  };

  const roundNumber = (number) => Math.round(number);

  const formatQuantity = (number) => parseFloat(number.toFixed(2));

  return (
    <div className="position-absolute z-3">
      <div className="fh left-pane">
        {notification.type && (
          <Notification
            color={notification.type === "error" ? "danger" : "success"}
            isOpen={isNotificationVisible}
            toggle={onDismissNotification}
          >
            {notification.message}
          </Notification>
        )}

        {currentRoom && projectSummary && (
          <FullViewContainer
            className={`project-summary ${isLoading ? "blurred" : ""}`}
          >
            <CrudModal
              isOpen={addGroupModal}
              toggle={toggleAddGroup}
              crudAction={(projectId, roomId, payload) =>
                addGroup({ projectId, roomId, payload })
              }
              id={projectId}
              roomId={currentRoom.id}
              text="Add Group"
            />
            {editGroup && (
              <CrudModal
                isOpen={editGroup}
                toggle={toggleEditGroup}
                crudAction={(projectId, groupId, payload) =>
                  updateGroup({
                    projectId,
                    groupId,
                    roomId: currentRoom.id,
                    payload,
                  })
                }
                id={projectId}
                name={currentEditModalName}
                groupId={selectionManager.selectedGroup()?.id}
                text="Edit Group"
              />
            )}
            <>
              <Accordion open={openedAccordionId} toggle={() => {}}>
                <DragDropContext onDragEnd={onGroupDragEnd}>
                  {currentRoom.groups.map((group, index) => (
                    <Droppable
                      isDropDisabled={group.category === "Section"}
                      droppableId={group.id.toString()}
                      key={group.id}
                    >
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={getListStyle(snapshot.isDraggingOver)}
                        >
                          <Accordion open={open} toggle={toggle} key={index}>
                            <AccordionItem
                              className={`border border-0 ${
                                selectionManager.isSelected(group) && "active"
                              }`}
                            >
                              {(fromOrderReview
                                ? group.modules.some((module) =>
                                    moduleIds.includes(module.id)
                                  )
                                : true) && (
                                <AccordionHeaderContainer
                                  className={`summary-item group-header hover-item p-2 ${
                                    selectionManager.isSelected(group) &&
                                    "active"
                                  } ${isEq(hoverItem, group) && "hover"}`}
                                  onClick={(e) => selectItem(group, e.shiftKey)}
                                  onMouseEnter={() => {
                                    setHoverItem(group);
                                  }}
                                  onMouseLeave={() => {
                                    setHoverItem(null);
                                  }}
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                      <AccordionHeader
                                        targetId={index.toString()}
                                        className={`group-name`}
                                      >
                                        <GroupInfoContainer className="d-flex justify-content-between fw-bold">
                                          <div className="mb-0">
                                            {group.name}
                                            {fromOrderReview && (
                                              <span
                                                className="m-1 px-1 bg-secondary text-white"
                                                style={{
                                                  borderRadius: "50%",
                                                }}
                                              >
                                                {
                                                  group.modules.filter(
                                                    (module) =>
                                                      moduleIds.includes(
                                                        module.id
                                                      )
                                                  ).length
                                                }
                                              </span>
                                            )}{" "}
                                          </div>
                                        </GroupInfoContainer>
                                      </AccordionHeader>
                                    </div>
                                    {access.group && !fromOrderReview && (
                                      <ProjectDropDown
                                        isOpen={
                                          groupDropdown[group.id] === group.id
                                        }
                                        toggle={() => {
                                          setCurrentGroup(group);
                                          setCurrentEditModalName(group.name);
                                          toggleGroupDropdown(group.id);
                                        }}
                                        toggleModal={toggleEditGroup}
                                        id={projectId}
                                        groupId={group.id}
                                        text="Group"
                                      />
                                    )}
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    {summary?.price &&
                                      group.price &&
                                      group.price != 0 &&
                                      group.price_per_sqft &&
                                      group.price_per_sqft != 0 && (
                                        <div>
                                          <p className="m-0">
                                            ₹
                                            {roundNumber(
                                              group.price
                                            ).toLocaleString("en-IN")}{" "}
                                          </p>
                                          <p className="m-0 text-secondary">
                                            ₹
                                            {roundNumber(
                                              group.price_per_sqft
                                            ).toLocaleString("en-IN")}{" "}
                                            / sq.ft.
                                          </p>
                                        </div>
                                      )}
                                  </div>
                                </AccordionHeaderContainer>
                              )}
                              <AccordionBody accordionId={index.toString()}>
                                <div>
                                  {group.modules
                                    ?.filter((orderItem) =>
                                      fromOrderReview
                                        ? moduleIds.includes(orderItem.id)
                                        : true
                                    )
                                    .map((orderItem, orderItemId) => (
                                      <Draggable
                                        key={orderItem.id}
                                        draggableId={orderItem.id.toString()}
                                        index={orderItemId}
                                        isDragDisabled={
                                          !access.customize_module ||
                                          orderItem.is_packed
                                        }
                                      >
                                        {(
                                          orderItemProvided,
                                          orderItemSnapshot
                                        ) => (
                                          <div
                                            ref={orderItemProvided.innerRef}
                                            {...orderItemProvided.draggableProps}
                                            {...orderItemProvided.dragHandleProps}
                                            style={getItemStyle(
                                              orderItemSnapshot.isDragging,
                                              orderItemProvided.draggableProps
                                                .style
                                            )}
                                          >
                                            <ItemContainer
                                              orderItem={orderItem}
                                              index={orderItemId}
                                              group={group}
                                            />
                                            <div>
                                              <DragDropContext
                                                onDragStart={() => {
                                                  setSortingContainer(
                                                    orderItem
                                                  );
                                                  setSortingGroup(group);
                                                }}
                                                onDragEnd={onContainerDragEnd}
                                              >
                                                <Droppable
                                                  droppableId={`droppable-${orderItem.id}`}
                                                >
                                                  {(provided, snapshot) => (
                                                    <div
                                                      {...provided.droppableProps}
                                                      ref={provided.innerRef}
                                                      style={getListStyle(
                                                        snapshot.isDraggingOver
                                                      )}
                                                    >
                                                      {orderItem.children?.map(
                                                        (child, index) => (
                                                          <Draggable
                                                            key={child.id}
                                                            draggableId={child.id.toString()}
                                                            index={index}
                                                            isDragDisabled={
                                                              !access.customize_module
                                                            }
                                                          >
                                                            {(
                                                              provided,
                                                              snapshot
                                                            ) => (
                                                              <div
                                                                ref={
                                                                  provided.innerRef
                                                                }
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={getItemStyle(
                                                                  snapshot.isDragging,
                                                                  provided
                                                                    .draggableProps
                                                                    .style
                                                                )}
                                                              >
                                                                <ItemContainer
                                                                  group={group}
                                                                  orderItem={
                                                                    child
                                                                  }
                                                                  childItems
                                                                  index={index}
                                                                />
                                                              </div>
                                                            )}
                                                          </Draggable>
                                                        )
                                                      )}
                                                      {provided.placeholder}
                                                      {orderItem.is_container_cabinet && (
                                                        <div
                                                          className="d-flex align-items-center px-5 border-bottom"
                                                          style={{
                                                            columnGap: "30px",
                                                            padding: "15px 0",
                                                            backgroundColor:
                                                              "#DDD",
                                                            borderTop:
                                                              "1px solid lightgray",
                                                          }}
                                                        >
                                                          <div>
                                                            <Icon className="fa fa-reply fa-rotate-180 ms-4" />
                                                          </div>
                                                          <Button
                                                            disabled={
                                                              !access.add_module
                                                            }
                                                            onClick={() => {
                                                              setGroupIdToAddModules(
                                                                group.id
                                                              );
                                                              setContainerIdToAddModules(
                                                                orderItem.id
                                                              );
                                                              setClearSearch(
                                                                true
                                                              );
                                                              setIsSubModule(
                                                                true
                                                              );
                                                            }}
                                                            outline
                                                            size="sm"
                                                            style={
                                                              group.id ===
                                                                groupIdToAddModules &&
                                                              orderItem.id ===
                                                                containerIdToAddModules
                                                                ? {
                                                                    background:
                                                                      "#6c757d",
                                                                    color:
                                                                      "white",
                                                                  }
                                                                : {}
                                                            }
                                                          >
                                                            <i className="fa-solid fa-circle-plus me-2"></i>
                                                            Add Sub-Module
                                                          </Button>
                                                        </div>
                                                      )}
                                                    </div>
                                                  )}
                                                </Droppable>
                                              </DragDropContext>
                                            </div>
                                          </div>
                                        )}
                                      </Draggable>
                                    ))}

                                  {!fromOrderReview &&
                                    group.walls?.map((wall, index) => {
                                      return (
                                        <div
                                          key={index}
                                          className={`summary-item wall-item ${
                                            selectionManager.isSelected(wall) &&
                                            "active"
                                          }`}
                                          onClick={(e) => {
                                            selectItem(wall);
                                          }}
                                        >
                                          <div className="item-name">
                                            {wall.name}
                                          </div>
                                          {summary?.measurement && (
                                            <div className="dimensions">
                                              {wall.dimensions.height} H x{" "}
                                              {wall.dimensions.width} W
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })}
                                </div>
                                {provided.placeholder}
                              </AccordionBody>
                            </AccordionItem>
                          </Accordion>
                        </div>
                      )}
                    </Droppable>
                  ))}
                  <div>
                    {!fromOrderReview &&
                      currentRoom.walls.map((wall, index) => {
                        return (
                          <div
                            className={`ps-2 summary-item wall-item ${
                              selectionManager.isSelected(wall) && "active"
                            } ${isEq(hoverItem, wall) && "hover"}`}
                            onClick={(e) => {
                              selectItem(wall);
                            }}
                            onMouseEnter={() => {
                              setHoverItem(wall);
                            }}
                            onMouseLeave={() => {
                              setHoverItem(null);
                            }}
                          >
                            <div className="item-name">{wall.name}</div>
                            {summary?.measurement && (
                              <div className="dimensions">
                                {wall.dimensions.height} H x{" "}
                                {wall.dimensions.width} W
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </div>

                  <Droppable droppableId="external">
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        {currentRoom.modules.map(
                          (orderItem, index) =>
                            (fromOrderReview
                              ? moduleIds.includes(orderItem.id)
                              : true) && (
                              <Draggable
                                key={orderItem.id}
                                draggableId={orderItem.id.toString()}
                                index={index}
                                isDragDisabled={!access.customize_module}
                              >
                                {(provided) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={getItemStyle(
                                      false,
                                      provided.draggableProps.style
                                    )}
                                  >
                                    <ItemContainer orderItem={orderItem} />
                                  </div>
                                )}
                              </Draggable>
                            )
                        )}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Accordion>
            </>
          </FullViewContainer>
        )}
      </div>

      {isPopoverOpen &&
        (() => {
          const orderItem = isPopoverOpen;
          const boundingClients = orderItemBoundingClients;

          return (
            <div
              className="d-flex align-items-center position-absolute z-3"
              style={{
                top: `${boundingClients.top - 200}px`,
                left: `${boundingClients.right + 5}px`,
                width: "max-content",
                transform: "translateY(-45%)",
              }}
            >
              <div
                onClick={(e) => {
                  clearPopover();
                  e.stopPropagation();
                }}
                className="position-absolute bg-white rounded-circle pointer z-2"
                style={{
                  top: "-0.8rem",
                  right: "-0.5rem",
                  border: "1px solid #283039",
                  padding: "4px 6px 0 6px",
                }}
              >
                <i className="fa-solid fa-xmark fs-6" />
              </div>
              <RightArrowPointer />
              <div className="pricing-table-container">
                <table className="pricing-table">
                  <tbody>
                    {BASE_TYPES.map(({ type, addonsType }, baseIndex) => {
                      if (!orderItem.price_meta[type]) return;
                      if (orderItem.price_meta[type].measurement <= 0) return;

                      const addons = orderItem.price_meta[type].addons
                        .map((addon) => {
                          if (addon.price) return addon;
                        })
                        .filter((addon) => addon);

                      addons.sort((x, y) => {
                        const indexA = addonsType.indexOf(x["type"]);
                        const indexB = addonsType.indexOf(y["type"]);

                        if (indexA === -1 && indexB === -1) return 0; // Both not in addonsType, preserve original order
                        if (indexA === -1) return 1; // `x` not in addonsType, move it after `y`
                        if (indexB === -1) return -1; // `y` not in addonsType, move it after `x`

                        return indexA - indexB; // Both in addonsType, sort by index in addonsType
                      });

                      const isTypeShell = type === "shell";
                      let baseTypeRate =
                        orderItem.price_meta[type].rate_with_addons;

                      const baseTypePrice =
                        orderItem.price_meta[type].price_with_addons;

                      return (
                        <tr
                          onMouseEnter={() =>
                            toggleAddOnPopover(orderItem.id + "_" + baseIndex)
                          }
                          onMouseLeave={() => setIsAddOnPopoverOpen("")}
                          key={`${orderItem.id}_${baseIndex}`}
                          className="position-relative"
                        >
                          <td style={{ width: "300px" }}>
                            <div className="fw-bold">
                              {`${orderItem.price_meta[type].name}`}
                            </div>
                            <div className="d-flex flex-wrap">
                              {(() => {
                                let count = 0;

                                return addons.map((addon, addonIndex) => {
                                  count++;

                                  return (
                                    <div key={addonIndex}>
                                      {count !== 1 && (
                                        <span className="mx-1">/</span>
                                      )}
                                      <span className="unit">{addon.name}</span>
                                      <span className="ms-1">
                                        {addon.value_name}
                                      </span>
                                    </div>
                                  );
                                });
                              })()}
                            </div>
                          </td>
                          <td>
                            ₹
                            {roundNumber(
                              isTypeShell ? baseTypePrice : baseTypeRate
                            ).toLocaleString("en-IN")}{" "}
                            <span className="unit">
                              {isTypeShell
                                ? "/ no."
                                : unitMapper[orderItem.price_meta[type].unit]}
                            </span>
                          </td>
                          <td>
                            {isTypeShell
                              ? 1
                              : formatQuantity(
                                  orderItem.price_meta[type].measurement
                                )}{" "}
                            <span className="unit">
                              {isTypeShell
                                ? "no."
                                : unitsMapper[orderItem.price_meta[type].unit]}
                            </span>
                          </td>
                          <td className="text-end">
                            ₹
                            {roundNumber(baseTypePrice).toLocaleString("en-IN")}
                          </td>
                          {isAddOnPopoverOpen ==
                            orderItem.id + "_" + baseIndex && (
                            <div
                              className="d-flex align-items-center position-absolute top-50 start-100"
                              style={{
                                transform: "translateY(-50%)",
                              }}
                            >
                              <RightArrowPointer color="#283039" />
                              <div className="details-popup">
                                <div
                                  className="d-flex justify-content-between align-items-center px-3 column-gap-5"
                                  style={{
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div>
                                    {orderItem.price_meta[type].name}{" "}
                                    <span className="unit">(base)</span>
                                  </div>
                                  <div className="fw-bold">
                                    ₹
                                    {roundNumber(
                                      isTypeShell
                                        ? orderItem.price_meta[type].price
                                        : orderItem.price_meta[type].base_rate
                                    )}
                                  </div>
                                </div>
                                {addons.length > 0 && (
                                  <>
                                    <div
                                      className="px-3 py-2 fw-bold bg-secondary-subtle"
                                      style={{ marginBottom: "10px" }}
                                    >
                                      Upgrades
                                    </div>
                                    <div className="d-flex px-3 pb-2 column-gap-4">
                                      <div className="d-flex flex-column row-gap-2">
                                        {addons.map((addon, addonIndex) => (
                                          <div key={addonIndex}>
                                            <span className="unit me-2">
                                              {addon.name}
                                            </span>
                                            {addon.value_name}
                                          </div>
                                        ))}
                                      </div>
                                      {isTypeShell && (
                                        <>
                                          <div className="d-flex flex-column fw-medium row-gap-2">
                                            {addons.map((addon, addonIndex) => (
                                              <div key={addonIndex}>
                                                ₹
                                                {roundNumber(
                                                  addon.base_rate
                                                ).toLocaleString("en-IN")}
                                              </div>
                                            ))}
                                          </div>
                                          <div className="d-flex flex-column row-gap-2">
                                            {addons.map((addon, addonIndex) => (
                                              <div key={addonIndex}>
                                                {formatQuantity(
                                                  addon.multiplier
                                                )}{" "}
                                                <span className="unit">
                                                  {shellNoUnitAddons.includes(
                                                    addon.type
                                                  )
                                                    ? "nos."
                                                    : "sq.ft."}
                                                </span>
                                              </div>
                                            ))}
                                          </div>
                                        </>
                                      )}
                                      <div className="d-flex flex-column row-gap-2">
                                        {addons.map((addon, addonIndex) => (
                                          <div
                                            key={addonIndex}
                                            className="fw-bold text-end"
                                          >
                                            ₹
                                            {roundNumber(
                                              isTypeShell
                                                ? addon.price
                                                : addon.base_rate
                                            ).toLocaleString("en-IN")}
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </>
                                )}
                                <div className="px-3 pt-3 d-flex justify-content-end align-items-center border-top border-secondary-subtle">
                                  <div className="fw-bold">Total</div>
                                  <div className="ms-2 active-dimension fw-bold">
                                    ₹
                                    {roundNumber(
                                      isTypeShell ? baseTypePrice : baseTypeRate
                                    ).toLocaleString("en-IN")}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="p-3 border-top border-secondary-subtle">
                  {orderItem.is_discounted && (
                    <div className="d-flex justify-content-end mb-2">
                      <span className="fw-bold">Total</span>
                      <span className="ms-2 grey_letter fw-bold text-decoration-line-through">
                        ₹
                        {roundNumber(orderItem.original_price).toLocaleString(
                          "en-IN"
                        )}
                      </span>
                    </div>
                  )}
                  <div className="d-flex justify-content-end align-items-center">
                    <span className="fw-bold">
                      {orderItem.is_discounted ? "After Discount" : "Total"}
                    </span>
                    <span className="fs-14px ms-2 active-dimension fw-bold">
                      ₹{roundNumber(orderItem.price).toLocaleString("en-IN")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })()}
    </div>
  );
};

export default ModuleListAccordion;
